import { render } from "./PledgeDefinitionList.vue?vue&type=template&id=28326a7a&scoped=true"
import script from "./PledgeDefinitionList.vue?vue&type=script&lang=js"
export * from "./PledgeDefinitionList.vue?vue&type=script&lang=js"

import "./PledgeDefinitionList.vue?vue&type=style&index=0&id=28326a7a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28326a7a"]])

export default __exports__